module.exports = __webpack_public_path__ + "img/file.a9f965fc.svg";